/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Interact_QuestionInputs */

const en_onboarding_interact_question = /** @type {(inputs: Onboarding_Interact_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do you usually interact with your study or research materials?`)
};

const es_onboarding_interact_question = /** @type {(inputs: Onboarding_Interact_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo interactúas normalmente con tus materiales de estudio o investigación?`)
};

/**
* | output |
* | --- |
* | "How do you usually interact with your study or research materials?" |
*
* @param {Onboarding_Interact_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_interact_question = /** @type {((inputs?: Onboarding_Interact_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Interact_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_interact_question(inputs)
	return en_onboarding_interact_question(inputs)
});